import styled from "styled-components";

const StyledShape = styled.div`
  width: 12.03px;
  height: 9.5px;
  left: -0.01px;
  top: 1.25px;
  position: absolute;
  background: #004ecc;
`;

const StyledLabelspan = styled.span`
  color: #1b1b1b;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;

const StyledLink01span = styled.span`
  color: #606060;
  font-size: 16px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 20.48px;
  word-wrap: break-word;
`;

const StyledMissionnamespan = styled.span`
  color: #172a3f;
  font-size: 20px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
`;

const StyledDeployedatspan = styled.span`
  color: #606060;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;

const Styled12252023332pmspan = styled.span`
  color: #1b1b1b;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;

const StyledDeployedbyspan = styled.span`
  color: #606060;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 300;
  line-height: 19.6px;
  word-wrap: break-word;
`;

const StyledStockchaser = styled.div`
  width: 29.16px;
  height: 8.89px;
  left: 0px;
  top: 10.48px;
  position: absolute;
  opacity: 0.3;
  box-shadow: 5px 5px 5px;
  filter: blur(2.5px);
`;

const StyledStockchaser01 = styled.div`
  width: 29.16px;
  height: 17.52px;
  left: 0px;
  top: 2.05px;
  position: absolute;
`;

const StyledVector = styled.div`
  width: 20.18px;
  height: 5.04px;
  left: 3.68px;
  top: 13.09px;
  position: absolute;
  mix-blend-mode: color;
  background: #3f7f7d;
`;

const StyledLink03span = styled.span`
  color: #3f7f7d;
  font-size: 14px;
  font-family: Readex Pro;
  font-weight: 400;
  line-height: 19.6px;
  word-wrap: break-word;
`;

const StyledGroup = styled.div`
  width: 112px;
  height: 20px;
  left: 0px;
  top: 0px;
  position: absolute;
  opacity: 0;
`;

const StyledGroup01 = styled.div`
  width: 20px;
  height: 20px;
  left: 0px;
  top: 0px;
  position: absolute;
`;

const StyledFrame01 = styled.div`
  align-self: stretch;
  padding-left: 8px;
  padding-right: 8px;
  justify-content: flex-start;
  align-items: center;
  display: flex;
`;

const StyledFrame787883744 = styled.div`
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  display: flex;
`;

const StyledLink02 = styled.div`
  border-radius: 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
`;

const StyledRetry1progressloading = styled.div`
  width: 12px;
  height: 12px;
  position: relative;
`;

const StyledIcon = styled.div`
  width: 20px;
  height: 20px;
  position: relative;
`;

const StyledFleet = styled.div`
  width: 30.48px;
  height: 20px;
  position: relative;
`;

const StyledFrame = styled.div`
  padding: 4px;
  position: relative;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

const StyledLink = styled.div`
  border-radius: 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: inline-flex;
  cursor: pointer;
  transition: opacity 0.3s;

  &:hover {
    opacity: 0.8;
  }

  svg {
    margin-left: 8px;
  }
`;

const StyledCellparts = styled.div`
  height: 20px;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  display: flex;
`;

const StyledMissionStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledContainer = styled.div`
  height: 24px;
  padding-top: 2px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: inline-flex;
`;

const StyledFrame787883745 = styled.div`
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
`;

const StyledFrame787883749 = styled.div`
  align-self: stretch;
  justify-content: space-between;
  align-items: center;
  display: inline-flex;
`;

const StyledFrame787883747 = styled.div`
  height: 48px;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  flex-wrap: wrap;
  align-content: center;
`;

const StyledFrame787883729 = styled.div`
  flex: 1 1 0;
  height: 104px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  display: inline-flex;
`;

const StyledSidebarHeader = styled.div`
  width: 100%;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 24px;
  padding-bottom: 24px;
  overflow: hidden;
  border-bottom: 1px #e9e9e9 solid;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
  background: white;
`;

// Export with the names used in the component
export const SidebarHeader = StyledSidebarHeader;
export const Frame787883729 = StyledFrame787883729;
export const Frame787883749 = StyledFrame787883749;
export const MissionStatus = StyledMissionStatus;
export const Group = StyledGroup;
export const Frame = StyledFrame;
export const Group01 = StyledGroup01;
export const Retry1ProgressLoading = StyledRetry1progressloading;
export const Shape = StyledShape;
export const Frame01 = StyledFrame01;
export const Label = StyledLabelspan;
export const Container = StyledContainer;
export const Link = StyledLink;
export const Link01 = StyledLink01span;
export const Icon = StyledIcon;
export const MissionName = StyledMissionnamespan;
export const Frame787883747 = StyledFrame787883747;
export const Frame787883744 = StyledFrame787883744;
export const DeployedAt = StyledDeployedatspan;
export const DeployedAtTime = Styled12252023332pmspan;
export const Frame787883745 = StyledFrame787883745;
export const DeployedBy = StyledDeployedbyspan;
export const CellParts = StyledCellparts;
export const Fleet = StyledFleet;
export const Stockchaser = StyledStockchaser;
export const Stockchaser01 = StyledStockchaser01;
export const Vector = StyledVector;
export const Link02 = StyledLink02;
export const Link03 = StyledLink03span;
